<div class="card mb-3">
  <div class="card-header">
    {{ 'authenticated.patients.edit.inquiries.header' | translate }}
  </div>

  <div class="card-body">
    @if (isBackofficeUser) {
      <form [formGroup]="form" class="row">

        <div class="col-12 col-lg-3 py-1">
          <app-multi-select-with-service
            [service]="addableDoctorService"
            [searchOnField]="'name'"
            [formControl]="form.controls.doctor"
            label="{{'authenticated.patients.edit.inquiries.form.doctor_id.label' | translate }}"
            [errorMessages]="{required: ('authenticated.patients.edit.inquiries.form.doctor_id.validation_messages.required' | translate)}"
            [sort]="'-created_at'"
            [selectionMode]="'single_model'"

          ></app-multi-select-with-service>
        </div>

        <div class="col-12 col-lg-6 py-1">
          <app-form-group
            [formControl]="form.controls.question"
            type="textarea"
            [minRows]="1"
            label="{{'authenticated.patients.edit.inquiries.form.question.label' | translate }}"
          ></app-form-group>
        </div>

        <div class="col-12 col-lg-3 py-1 d-flex align-items-start">
          <button
            type="button"
            class="btn btn-primary w-100 mt-4"
            (click)="showEmailModal()"
            [disabled]="isWaitingForResponse"
          >{{ 'authenticated.patients.edit.inquiries.create_btn' | translate }}
          </button>
        </div>

      </form>
    }

    @for (inquiry of inquiries; track inquiry.id) {
      <app-authenticated-patients-edit-inquiries-inquiry
        [inquiry]="inquiry"
        (inquiryUpdated)="loadInquiries()"
      ></app-authenticated-patients-edit-inquiries-inquiry>
    }
  </div>
</div>

@if (selectedDoctor) {
  <ng-template #emailBuilderModal>
    <app-email-send
      [type]="EmailTypeEnum.NEW_INQUIRY"
      [recipient]="selectedDoctor"
      [sendEmail]="false"
      [pending]="isWaitingForResponse"
      (sendEmailEvent)="save($event)"
      (closeEvent)="onCloseEmailModal()"
    ></app-email-send>
  </ng-template>
}
